import { useLocation, Link } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import useClubVocab from '../../hooks/useClubVocab';
import {
  MdDashboard, MdPersonAdd, MdPeople, MdPayments, MdMenu,
  MdQrCode, MdReceiptLong, MdCampaign, MdPerson, MdEventAvailable,
} from 'react-icons/md';
import { TRIAL_ENABLED } from '../../config/features';

const TABS = {
  admin: [
    { to: '/admin/dashboard',      Icon: MdDashboard, label: 'Home'     },
    ...(TRIAL_ENABLED ? [{ to: '/admin/trial-students', Icon: MdPersonAdd, label: 'Intake' }] : []),
    { to: '/admin/students',       Icon: MdPeople,    label: 'Students' },
    { to: '/admin/payments',       Icon: MdPayments,  label: 'Fees'     },
    { more: true,                  Icon: MdMenu,      label: 'More'     },
  ],
  trainer: [
    { to: '/trainer/dashboard', Icon: MdDashboard,   label: 'Home'     },
    { to: '/trainer/attendance', Icon: MdEventAvailable, label: 'Attendance' },
    { to: '/trainer/students',  Icon: MdPeople,      label: 'Students' },
    { to: '/trainer/expenses',  Icon: MdReceiptLong, label: 'Expenses' },
    { more: true,               Icon: MdMenu,        label: 'More'     },
  ],
  student: [
    { to: '/student/dashboard', Icon: MdDashboard, label: 'Home'    },
    { to: '/student/fees',      Icon: MdPayments,  label: 'Fees'    },
    { to: '/student/notices',   Icon: MdCampaign,  label: 'Notices' },
    { to: '/student/profile',   Icon: MdPerson,    label: 'Profile' },
    { more: true,               Icon: MdMenu,      label: 'More'    },
  ],
};

const DASH_ROUTES = ['/admin/dashboard', '/trainer/dashboard', '/student/dashboard'];

export default function MobileBottomBar({ onMenuToggle }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const v = useClubVocab();
  const tabs = TABS[user?.role] || [];
  // "Students" → "Members" for gyms/yoga; byte-identical for taekwondo. Mirrors Sidebar.labelFor.
  const labelFor = (label) => label.replace(/\bStudents\b/g, v.members).replace(/\bStudent\b/g, v.member);

  if (!tabs.length) return null;

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-nav border-t border-divider"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="flex">
        {tabs.map(({ to, Icon, label, more }) => {
          const isActive = !more && (
            DASH_ROUTES.includes(to) ? pathname === to : pathname.startsWith(to)
          );

          if (more) {
            return (
              <button
                key="more"
                onClick={onMenuToggle}
                className="flex-1 flex flex-col items-center justify-center gap-0.5 py-2.5 text-muted active:text-secondary transition-colors"
                style={{ minHeight: 56 }}
              >
                <Icon className="text-[22px]" />
                <span className="text-[10px] font-semibold">{labelFor(label)}</span>
              </button>
            );
          }

          return (
            <Link
              key={to}
              to={to}
              className={`flex-1 flex flex-col items-center justify-center gap-0.5 py-2.5 transition-colors ${
                isActive ? 'text-primary' : 'text-muted active:text-secondary'
              }`}
              style={{ minHeight: 56 }}
            >
              <Icon className={`text-[22px] ${isActive ? 'text-primary' : ''}`} />
              <span className={`text-[10px] font-semibold ${isActive ? 'text-primary' : ''}`}>
                {labelFor(label)}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
